import "./import/modules";
import $ from "jquery";
import StickySidebar from "sticky-sidebar";
import Modal from 'bootstrap/js/dist/modal';

require("@fancyapps/fancybox");

var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);

$(document).ready(function() {
	let offset;

	if ($(window).width() > 767) {
		offset = 90
	} else {
		offset = 60
	}

	$('.jsScrollButton').on('click', function (e) {
		e.preventDefault();
		var getvalue = $(this).attr('href');
		$('html, body').stop().animate({scrollTop: $(getvalue).offset().top - offset }, 500);
	});


	if ($('.jsScrollBlock').length > 0 && $(window).width() < 1279) {

		$(window).scroll(function (){

			if ($(window).scrollTop() + $(window).height() > $('.jsScrollBlock').offset().top) {
				$('.jsFixedElement').addClass('is-hidden')
			} else {
				$('.jsFixedElement').removeClass('is-hidden')
			}
		})
	}

	if ($('.jsStickySidebar').length > 0) {
		const sidebar = new StickySidebar('.jsStickySidebar', {topSpacing: 120, bottomSpacing: 60,});
	}

	if (!isMobile) {
		$('html').addClass('is-desktop');
	}

});
